import SimpleBarCore from 'simplebar-core';
import SimpleBar, { Props } from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

const CustomScroll = (
  props: Props & React.RefAttributes<SimpleBarCore | null>,
) => {
  const { style, ...rest } = props;

  return (
    <SimpleBar
      {...rest}
      style={{ ...style, maxHeight: style?.maxHeight || '100%' }}
    />
  );
};

export default CustomScroll;
